
import styled from "@emotion/styled";


export const CustomWrapper = styled.div(({ theme: { designTokens: DT }, isApplyCustomLayout, pathname }) => {

    if (!isApplyCustomLayout) return ``
    return `
        padding: 42px 32px;
        border-radius: 8px;
        border: 1px solid ${DT.T_COLOR_LINE_PRIMARY_LIGHT};
        background-color: ${DT.T_COLOR_BG_DEFAULT_BRIGHT};
        .register-form-top {
            margin-bottom: 48px;
        }
        .social-title-left {
            position: relative;
            margin-bottom: 20px;

        }
        .register-form-wrapper {
            padding-top: 0px;
        }
        .register-tc-wrapper {
            margin-top: 48px;
        }
    `;
});



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomWrapper/style.jsx